import { css } from '@emotion/css';
import React from 'react';
import { ErrorInput } from './Error';
import { Guidance } from './Guidance';
import { Units } from './Units';
const bottomRowStyles = css `
  display: flex;
  padding-top: 3px;
  gap: 16px;
`;
export const InputBottomRow = ({ testId, error, id, guidance, units, isDisabled }) => {
    return error || guidance || units ? (React.createElement("div", { className: bottomRowStyles, "data-testid": testId && `${testId}-bottom-row` },
        !error && React.createElement(Guidance, { id: id, guidance: guidance, testId: testId }),
        React.createElement(ErrorInput, { id: id, error: error, testId: testId }),
        React.createElement(Units, { units: units, testId: testId, isDisabled: isDisabled }))) : null;
};
